import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useBrandingQueryV1(organizationUnitId?: number | Ref<number>, ) {
	const _organizationUnitId = isRef<number>(organizationUnitId) ? organizationUnitId : ref<number>(organizationUnitId)
	const result = {
		organizationUnitId: _organizationUnitId,
		...useQuery(() => new q.BrandingQueryV1(_organizationUnitId.value))
	}
	return {
		...result,
		runBrandingQueryV1: result.run,
		modelBrandingQueryV1: result.model,
	}
}

export function useInstanceSetupQueryV1() {
	const result = {
		...useQuery(() => new q.InstanceSetupQueryV1())
	}
	return {
		...result,
		runInstanceSetupQueryV1: result.run,
		modelInstanceSetupQueryV1: result.model,
	}
}

export function useOrganizationAdminDetailsQueryV1(tenantId?: number | Ref<number>, ) {
	const _tenantId = isRef<number>(tenantId) ? tenantId : ref<number>(tenantId)
	const result = {
		tenantId: _tenantId,
		...useQuery(() => new q.OrganizationAdminDetailsQueryV1(_tenantId.value))
	}
	return {
		...result,
		runOrganizationAdminDetailsQueryV1: result.run,
		modelOrganizationAdminDetailsQueryV1: result.model,
	}
}

export function useOrganizationUnitQueryV1(organizationUnitId?: number | Ref<number>, ) {
	const _organizationUnitId = isRef<number>(organizationUnitId) ? organizationUnitId : ref<number>(organizationUnitId)
	const result = {
		organizationUnitId: _organizationUnitId,
		...useQuery(() => new q.OrganizationUnitQueryV1(_organizationUnitId.value))
	}
	return {
		...result,
		runOrganizationUnitQueryV1: result.run,
		modelOrganizationUnitQueryV1: result.model,
	}
}

export function useOrganizationUnitsQueryV1() {
	const result = {
		...useQuery(() => new q.OrganizationUnitsQueryV1())
	}
	return {
		...result,
		runOrganizationUnitsQueryV1: result.run,
		modelOrganizationUnitsQueryV1: result.model,
	}
}

export function useSearchOrganizationUnitQueryV1(organizationUnitId?: number | Ref<number>, searchPhrase?: string | Ref<string>, ) {
	const _organizationUnitId = isRef<number>(organizationUnitId) ? organizationUnitId : ref<number>(organizationUnitId)
	const _searchPhrase = isRef<string>(searchPhrase) ? searchPhrase : ref<string>(searchPhrase)
	const result = {
		organizationUnitId: _organizationUnitId,
		searchPhrase: _searchPhrase,
		...useQuery(() => new q.SearchOrganizationUnitQueryV1(_organizationUnitId.value, _searchPhrase.value))
	}
	return {
		...result,
		runSearchOrganizationUnitQueryV1: result.run,
		modelSearchOrganizationUnitQueryV1: result.model,
	}
}

export function useSsoConfigurationQueryV1(tenantId?: number | Ref<number>, ) {
	const _tenantId = isRef<number>(tenantId) ? tenantId : ref<number>(tenantId)
	const result = {
		tenantId: _tenantId,
		...useQuery(() => new q.SsoConfigurationQueryV1(_tenantId.value))
	}
	return {
		...result,
		runSsoConfigurationQueryV1: result.run,
		modelSsoConfigurationQueryV1: result.model,
	}
}

export function useSystemStatsQueryV1() {
	const result = {
		...useQuery(() => new q.SystemStatsQueryV1())
	}
	return {
		...result,
		runSystemStatsQueryV1: result.run,
		modelSystemStatsQueryV1: result.model,
	}
}

